export const EXPERIMENT_FS_NAME_START_DATE = 'fs-prop:sponsored-ab-test-start-date';
export const EXPERIMENT_FS_NAME_END_DATE = 'fs-prop:sponsored-ab-test-end-date';
export const EXPERIMENT_FS_CLICK_NEXT_BTN_TIMEOUT = 'fs-prop:experiment-click-next-btn-timeout';
export const TARGETED_CATEGORIES = 'fs-prop:sponsored-ab-test-targeted-categories';
export const EXPERIMENT_COOKIE_NAME = 'fs-prop:sponsored-ab-test-cookie-name';
export const INNERVATE_GROUP_VALUE = 'fs-prop:sponsored-ab-test-innervate-group-value';
export const EXPERIMENT_COOKIE_WAIT_INTERVAL = 'fs-prop:sponsored-ab-test-cookie-wait-interval';
export const EXPERIMENT_COOKIE_MAX_TRIES = 'fs-prop:sponsored-ab-test-cookie-max-tries';
